import styled from 'styled-components';
import { min } from '../../../theme/breakpoints';

export const LegalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.875rem;
  text-align: center;
  padding: 1.25rem 3rem 0;

  @media screen and ${min('largeTablet')} {
    padding: 1.25rem;
    max-width: 300px;
    text-align: left;
    background: rgba(0, 0, 0, 0.4);
  }
  p {
    font-size: 0.75rem;
    margin-bottom: 0;

    @media screen and ${min('largeTablet')} {
      font-size: 0.875rem;
      color: ${({ theme }) => theme.colors.White};
    }
  }
  img {
    margin-right: 1rem;
    display: block;
    width: 35px;

    @media screen and ${min('largeTablet')} {
      width: 45px;
    }
  }
`;
